import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './BlogPost.module.css';

const BlogPost = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const loadBlogContent = async () => {
      try {
        const blogMap = {
          'understanding-zero-trust-architecture': '/content/blogs/zero-trust-architecture.md',
          'the-rise-of-ai-in-cybersecurity': '/content/blogs/ai-in-cybersecurity.md',
          'cloud-security-best-practices': '/content/blogs/cloud-security-best-practices.md'
        };

        if (!blogMap[slug]) {
          throw new Error('Blog post not found');
        }

        const response = await fetch(blogMap[slug]);
        if (!response.ok) {
          throw new Error('Failed to load blog content');
        }
        const text = await response.text();
        setContent(text);
      } catch (error) {
        console.error('Error loading blog post:', error);
        navigate('/blog-resources');
      } finally {
        setLoading(false);
      }
    };

    loadBlogContent();
  }, [slug, navigate]);

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Loading...</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <button onClick={() => navigate('/blog-resources')} className={styles.backButton}>
        ← Back to Blog
      </button>
      <article className={styles.blogPost}>
        <ReactMarkdown>{content}</ReactMarkdown>
      </article>
    </div>
  );
};

export default BlogPost;
